import request from '@/utils/request';
import {returnURL}from '@/api/login';
import store from "@/store";

   const siteName = returnURL();


export function callApi(url,method,model,responseType='json',requesttimeout = "50000") {
  if (navigator.onLine) {
   var payload = {
    RequestId: Math.floor((Math.random() * 10000000000) + 1),
    Data: model
  }

  let data = JSON.stringify(payload);
  return request({
    url:siteName + url,
    method: method,
    data,
    responseType:responseType,
    headers:{ 'content-type': 'application/json' },
    timeout: requesttimeout
  })
} else {
  let dm={
    rId:Math.floor((Math.random() * 10000000000) + 1),
    text:"No Internet Connection",
    color:"dark",
  }
  // alert('No Internet Connection');
  store.commit('SET_SNACKBARTEXT',dm)
}

}
export function callApi2(url,method,model,responseType='json') {
  var payload = {
    RequestId: Math.floor((Math.random() * 10000000000) + 1),
    Data: model
  }

  let data = JSON.stringify(payload);
  return request({
    url: url,
    method: method,
    data,
    responseType:responseType,
    headers:{ 'content-type': 'application/json' },
  })
}

